//src/pages/OldDashboard291025.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faAward, faTimes, faClockRotateLeft, faTrophy, faTag, faShippingFast, faShoppingCart, 
    faQuestionCircle, faSchoolCircleCheck, faMedal 
} from '@fortawesome/free-solid-svg-icons';
import '../styles/Dashboard.css';
import '../styles/Tooltip.css';
// import { FaTag, FaShippingFast, FaShoppingCart } from "react-icons/fa";

import DashboardGridData from '../components/DashboardGridData';
import MainLayout from '../layouts/MainLayout';

const OldDashboard291025 = () => {
  const navigate = useNavigate();
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const titleStyle = {
    color: module.isActive ? 'white' : 'gray',
    fontSize: '12px'
  };

  // Sort DashboardGridData first
const sortedDashboardData = DashboardGridData.sort((a, b) => {
  if (a.isActive !== b.isActive) return Number(b.isActive) - Number(a.isActive); // Active first
  if (a.moduleCat.localeCompare(b.moduleCat) !== 0) 
    return a.moduleCat.localeCompare(b.moduleCat); // Alphabetical order
  if (a.tabSN !== b.tabSN) return a.tabSN - b.tabSN; // Ascending order
  return a.title.localeCompare(b.title); // Alphabetical order
});

// Group modules by moduleCat
const groupedModules = sortedDashboardData.reduce((acc, module) => {
  if (!acc[module.moduleCat]) {
    acc[module.moduleCat] = [];
  }
  acc[module.moduleCat].push(module);
  return acc;
}, {});

// Create an array of categories from groupedModules and sort by tabSN
const sortedCategories = Object.keys(groupedModules).sort((a, b) => {
  const tabSN_A = sortedDashboardData.find(module => module.moduleCat === a)?.tabSN || 0; 
  const tabSN_B = sortedDashboardData.find(module => module.moduleCat === b)?.tabSN || 0;
  return tabSN_A - tabSN_B; // Ascending order
});

// Set the first category as active
const [activeCategory, setActiveCategory] = useState(sortedCategories[0]);
const [categoryInfo, setCategoryInfo] = useState('Think5Whys');

  // Function to handle category tab click
  const handleTabClick = (category) => {
    setActiveCategory(category);
    setCategoryInfo(category);
    setIsOverlayVisible(true); 
  };

  // useEffect(() => {
  //   getCategoryInfo(activeCategory);
  // }, [activeCategory]);

  const closeOverlay = () => {
    setIsOverlayVisible(false); 
  };

  // Function to return the FontAwesome icon based on the category
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Learning & Development':
        return <i className="fas fa-book-reader"></i>;
      case 'Improvement & Productivity':
        return <i className="fas fa-chart-line"></i>;
      case 'Product Marketplace':
        return <i className="fas fa-shopping-cart"></i>;
      case 'ThinkServices':
        return <i className="fas fa-laptop-house"></i>;
      case 'ThinkBPM':
        return <i className="fas fa-briefcase"></i>;
      case 'Pados / Locality':
        return <i className="fas fa-home"></i>;
      case 'Personal Information':
        return <i className="fas fa-user-circle"></i>;
      case 'ThinkSocial':
        return <i className="fas fa-users"></i>;
      case 'Daily Life':
        return <i className="fas fa-heart"></i>;
      case 'ThinkHealth':
        return <i className="fas fa-heartbeat"></i>;
      case 'ThinkJobs':
        return <i className="fas fa-briefcase"></i>;
      case 'Insight & Intelligence':
        return <i className="fas fa-lightbulb"></i>;
      case 'ThinkAds':
        return <i className="fas fa-gift"></i>;
      case 'ThinkAgri':
        return <i className="fas fa-tractor"></i>;
      case 'ThinkFinance':
        return <i className="fas fa-chart-line"></i>;  
      case 'ThinkContract':
        return <i className="fas fa-network-wired"></i>;  
      case 'ThinkExim':
        return <i className="fas fa-arrow-right-from-bracket"></i>;
      case 'ThinkEvent':
        return <i className="fas fa-calendar-day"></i>;
      case 'Tonics':
          return <i className="fas fa-question"></i>;
      case 'Community360':
          return <i className="fas fa-cubes"></i>;  
      case 'EarlySpark':
          return <i className="fas fa-fire"></i>;  
      case 'SkillSphere':
          return <i className="fas fa-wrench"></i>;  
      case 'ThinkTestBook':
          return <i className="fas fa-pen"></i>;    
      case 'CAP':
          return <i className="fas fa-graduation-cap"></i>;  
      case 'Coach':
        return <i className="fas fa-chalkboard-teacher"></i>;   
      case 'ThinkMath':
          return <i className="fas fa-calculator"></i>;  
      case 'ThinkPreSchool':
          return <i className="fas fa-child"></i>;   
      case 'DeepTeach':
          return <i className="fas fa-chalkboard-teacher"></i>;  
      case 'Visa & Travel':
          return <i className="fas fa-passport"></i>;                                                    
      default:
        return <i className="fas fa-cube"></i>;
    }
  };

  // Function to return the FontAwesome icon based on the category
  const getCategoryInfo = (category) => {
    switch (category) {
      case 'Learning & Development':
        return "Immersive Learning & Development";
      case 'Improvement & Productivity':
        return "Improvement & Productivity with Six Sigma for Public";
      case 'Product Marketplace':
        return "Comprehensive Product Marketplace";
      case 'ThinkServices':
        return "Comprehensive Services Marketplace";
      case 'ThinkBPM':
        return "Business Process Manageemnt & Project Management";
      case 'Pados / Locality':
        return "Pados / Locality";
      case 'Personal Information':
        return "Personal Information";
      case 'ThinkSocial':
        return "Social Modules";
      case 'Daily Life':
        return "Life & Busines Chronicles";
      case 'ThinkHealth':
        return "Healthcare Monitoring Modules";
      case 'ThinkJobs':
        return "Vertical Jobs";
      case 'BigData':
        return "Insight & Intelligence";
      case 'ThinkAds':
        return "Rewarding Ads";
      case 'ThinkAgri':
        return "Better Agriculture";
      case 'ThinkFinance':
        return "Managing Financial Aspects of Life";
      case 'ThinkContract':
        return "Comprehensive COntract Management Module"; 
      case 'ThinkExim':
        return "Export Import Marketplace";
      case 'ThinkEvent':
        return "End-to-End Event Management";
      case 'Tonics':
        return "Daily Doses of Knowledge";
      case 'Community360':
        return "End-to-End Community, Association, Society Management";  
      case 'EarlySpark':
        return "Immersive Educational Platform for School & Junior Colleges";  
      case 'SkillSphere':
        return "Skill Development Learning Programs"; 
      case 'ThinkTestBook':
        return "Immersive Test Series - MCQ & AI Powered Descriptive Questions";    
      case 'CAP':
        return "Immersive Digital Cources & Programs";  
      case 'D-SCUT':
        return "Digital School, College, University, Coaching, Tuition";   
      case 'ThinkMath':
        return "Maths Sphere"; 
      case 'ThinkPreSchool':
        return "PreSchool";    
      case 'DeepTeach':
        return "DeepTeach";     
      case 'Visa & Travel':
        return "VISA & Travel";                                              
      default:
        return "Think5Whys: Elevate Your Thinking From Why To Wisdom";
    }
  };

  // useEffect(() => {
  //   const hourHand = document.querySelector('.hour-hand');
  //   const minuteHand = document.querySelector('.minute-hand');
  //   const secondHand = document.querySelector('.second-hand');

  //   const setClock = () => {
  //     const now = new Date();
  //     const seconds = now.getSeconds();
  //     const minutes = now.getMinutes();
  //     const hours = now.getHours();

  //     const secondsDegrees = ((seconds / 60) * 360) + 90; // Offset by 90deg
  //     const minutesDegrees = ((minutes / 60) * 360) + ((seconds / 60) * 6) + 90;
  //     const hoursDegrees = ((hours / 12) * 360) + ((minutes / 60) * 30) + 90;

  //     secondHand.style.transform = `rotate(${secondsDegrees}deg)`;
  //     minuteHand.style.transform = `rotate(${minutesDegrees}deg)`;
  //     hourHand.style.transform = `rotate(${hoursDegrees}deg)`;
  //   }

  //   const intervalId = setInterval(setClock, 1000); 
  //   setClock(); 

  //   return () => clearInterval(intervalId); 
  // }, []);


  return (
    <DashboardLayout includeNavbarAndFooter={true}>
      <div className="min-h-full py-2 bg-gradient-to-r from-gray-800 via-lime-800 to-gray-800">
        <h3 className='text-xl font-bold text-white text-center mb-4'>User Dashboard</h3>
        <div className='flex flex-col justify-center'>
          {/* <div className="grid grid-cols-2 sm:grid-cols-6 gap-4 mb-2 mx-2 py-2 px-2 justify-center border-2 border-purple-400">
            <div className="flex justify-center mb-2 text-sm">
                <Link to="/aicounselling-help" className="flex items-center h-full">
                  <p className="spotsnap-title text-m mr-1 text-white bg-green-600 ">
                    <FontAwesomeIcon 
                      icon={faQuestionCircle} 
                      style={{ color: 'yellow', marginRight: '5px' }} 
                    />
                  </p>
                </Link>
                <Link to="/aicounselling" className="flex items-center h-full">
                  <p className="spotsnap-title text-m mr-1 text-white bg-green-600 ">
                    AI Counsellor 
                  </p>
                </Link>
            </div>
            <div className="flex justify-center mt-2 mb-4 text-sm">
              <Link to="/applause-marksheet-contest" className="flex items-center h-full">
                <p className="spotsnap-title text-m ml-1 mr-1 text-white bg-orange-600 ">
                  <FontAwesomeIcon icon={faMedal} style={{ color: 'yellow', marginRight: '5px'}} />
                </p>
              </Link>
              <Link to="/applause-hub-home" className="flex items-center h-full">
                <p className="spotsnap-title text-m mr-1 text-white bg-orange-600">
                  Marksheet!
                </p>
              </Link>
            </div>
            <div className="flex justify-center mb-2 text-sm">
                <Link to="/think5whys-db-list" className="flex items-center h-full">
                  <p className="spotsnap-title text-m ml-1 mr-1 text-white bg-purple-700">
                    <FontAwesomeIcon 
                      icon={faQuestionCircle} 
                      style={{ color: 'yellow', marginRight: '5px' }} 
                    />
                  </p>
                </Link>
                <Link to="/rcas/add" className="flex items-center h-full">
                  <p className="spotsnap-title text-m mr-1 text-white bg-purple-700">
                    RootSol: Act Now 
                  </p>
                </Link>
            </div>
            <div className="flex justify-center mb-2 text-sm">
                <Link to="/focus-timer-start" className="flex items-center h-full">
                  <p className="spotsnap-title text-m ml-1 mr-1 text-white bg-green-600">
                    <FontAwesomeIcon 
                      icon={faClockRotateLeft} 
                      style={{ color: 'yellow', marginRight: '5px' }} 
                    />Focus Timer
                  </p>
                </Link>
            </div>
            <div className="flex justify-center mb-2 text-sm">
              <Link to="/thinkleticsdashboard" className="flex items-center h-full">
                <p className="spotsnap-title text-m ml-1 mr-1 text-white bg-yellow-200" style={{ color: 'gray', backgroundColor: 'yellow', textAlign: 'center'}}>
                  <FontAwesomeIcon icon={faTrophy} style={{ color: 'gray', marginRight: '10px' }} />Thinkletics
                </p>
              </Link>
            </div>
            <div className="flex justify-center mb-2 text-sm">
              <Link to="/spotsnap" className="flex items-center h-full">
                <p className="spotsnap-title text-m text-white bg-blue-600">
                  <FontAwesomeIcon icon={faAward} style={{ color: 'gray', marginRight: '10px' }} />SpotSnap
                </p>
              </Link>
            </div>
          </div> */}
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-6 gap-6 mb-4 mx-4 py-4 px-4 border border-purple-500 rounded-lg bg-gradient-to-r from-purple-50 to-purple-100 shadow-lg">
            {/* AI Counselling */}
            <div className="flex flex-col items-center text-center">
              <Link to="/aicounselling-about" className="flex items-center justify-center w-20 h-20 rounded-full bg-green-600 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: 'yellow', fontSize: '24px' }} />
              </Link>
              <Link to="/aicounselling" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
                AI Counsellor
              </Link>
            </div>

            {/* Applause Marksheet */}
            <div className="flex flex-col items-center text-center">
              <Link to="/applause-marksheet-contest" className="flex items-center justify-center w-20 h-20 rounded-full bg-orange-600 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faMedal} style={{ color: 'yellow', fontSize: '24px' }} />
              </Link>
              <Link to="/applause-hub-home" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
                Marksheet!
              </Link>
            </div>

            {/* Think 5 Whys */}
            <div className="flex flex-col items-center text-center">
              <Link to="/think5whys-db-list" className="flex items-center justify-center w-20 h-20 rounded-full bg-purple-700 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: 'yellow', fontSize: '24px' }} />
              </Link>
              <Link to="/rcas/add" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
                RootSol: Act Now
              </Link>
            </div>

            {/* Focus Timer */}
            <div className="flex flex-col items-center text-center">
              {/* /focus-timer-start */}
              <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-green-600 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faClockRotateLeft} style={{ color: 'yellow', fontSize: '24px' }} />
              </Link>
              <p className="mt-2 text-sm font-medium text-gray-800">Focus Timer</p>
            </div>

            {/* Thinkletics */}
            <div className="flex flex-col items-center text-center">
              {/* /thinkleticsdashboard */}
              <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-yellow-300 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faTrophy} style={{ color: 'gray', fontSize: '24px' }} />
              </Link>
              <p className="mt-2 text-sm font-medium text-gray-800">Thinkletics</p>
            </div>

            {/* SpotSnap */}
            <div className="flex flex-col items-center text-center">
              {/* /spotsnap */}
              <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-600 hover:scale-105 transition-transform">
                <FontAwesomeIcon icon={faAward} style={{ color: 'gray', fontSize: '24px' }} />
              </Link>
              <p className="mt-2 text-sm font-medium text-gray-800">SpotSnap</p>
            </div>
          </div>

          <div 
            className="relative flex flex-col sm:flex-row items-center justify-center mb-8 mt-4 bg-gradient-to-r from-yellow-400 to-orange-600 text-white p-6 rounded-2xl shadow-xl w-full max-w-lg mx-auto cursor-pointer transition-all transform hover:scale-105 hover:shadow-2xl border-2 border-yellow-500"
            onClick={() => navigate("/roomanywhere")}
          >
            <div className="absolute -top-3 -left-3 bg-red-600 text-xs text-white px-3 py-1 rounded-full uppercase shadow-md flex items-center gap-2">
              <FontAwesomeIcon icon={faTag} className="text-yellow-300" /> Exclusive
            </div>

            <div className="absolute -bottom-3 right-3 bg-black text-[10px] text-white px-3 py-1 rounded-full uppercase shadow-md flex items-center gap-2">
              <FontAwesomeIcon icon={faShippingFast} className="text-yellow-300" /> Free Shipping 
            </div>

            <img 
              src="/api/downloads/orderflow/products/exclusive.png"
              alt="Exclusive Offer"
              className="w-28 h-auto rounded-lg shadow-lg mx-4"
            />

            <div className="text-center sm:text-left">
              <p className="text-xl font-bold tracking-wide">RoomAnywhere</p>
              <p className="text-xs text-gray-200 mt-1">Patent Pending | Become Reseller</p>
              
              <button className="mt-3 flex items-center gap-2 bg-red-500 text-white px-4 py-2 text-sm font-medium rounded-lg shadow-md hover:bg-red-700 transition">
                <FontAwesomeIcon icon={faShoppingCart} /> EMI Available
              </button>
            </div>
          </div>

        </div>
         
        <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 mb-250 mx-4">
          {Object.keys(groupedModules).map((category) => (
            <button
              key={category}
              onClick={() => handleTabClick(category)}
              className="text-sm flex flex-col items-center justify-center w-full max-w-xs p-4 bg-gradient-to-r from-teal-800 to-blue-800 text-white font-semibold rounded-lg shadow-md transform hover:scale-105 transition-all duration-300 ease-out sm:w-auto"

            >
              {/* Icon above the category name */}
              <div style={{ fontSize: '24px', marginBottom: '10px' }}>
                {getCategoryIcon(category)}
              </div>
              <span className="text-m font-semibold flex items-center justify-center text-center">{category}</span>
            </button>
          ))}
        </div>
        <div className='flex justify-center mb-4'>
          <Link to="/dashboard-others" className="flex items-center h-full">
            <h1 className="spotsnap-title text-m ml-1 mr-1" style={{ color: 'black', backgroundColor: 'yellow', textAlign: 'center', height: '100%' }}>
              Other Dashboard
            </h1>
          </Link>
        </div>
        {/* Overlay for Modules Display */}
        {isOverlayVisible && (

          <div
            className="overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'darkblue',
              display: 'flex',
              flexDirection: 'column', 
              alignItems: 'center', 
              zIndex: 100,
              padding: '20px',
              overflowY: 'auto', 
            }}
          >
          <div>
            {/* First Close Icon */}
            <button
              onClick={closeOverlay}
              style={{
                background: 'none',
                border: 'none',
                color: 'red',
                fontSize: '24px',
                cursor: 'pointer',
                marginBottom: '20px', 
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>    

          <div className='flex justify-center mt-12 mb-4 text-xl text-yellow-200'>{activeCategory}</div>
          {/* <div className='flex justify-center mt-4 mb-4 text-xl text-yellow-200'>{categoryInfo}</div> */}

          {/* Module Display Area */}
          <div className="min-h-full grid grid-cols-2 sm:grid-cols-6 gap-6 mb-4">
            {groupedModules[activeCategory]
              .sort((a, b) => b.isActive - a.isActive)
              .map((module, index) => (
                <div key={index} className="module-card" style={{ textAlign: 'center', margin: '15px', width: '150px' }}>
                  {module.isActive ? (
                    <Link to={module.landingPageUrl} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <img
                        src={module.imageUrl}
                        alt={module.title}
                        width="100%"
                        height="auto"
                        style={{ borderRadius: '8px', marginBottom: '10px' }}
                      />
                      <div className="module-title" style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                        {module.title}
                      </div>
                    </Link>
                  ) : (
                    <>
                      <img
                        src={module.imageUrl}
                        alt={module.title}
                        width="100%"
                        height="auto"
                        style={{ borderRadius: '8px', marginBottom: '10px', opacity: '0.5' }}
                      />
                      <div className="module-title" style={{ color: 'gray', fontSize: '14px' }}>
                        {module.title}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* Second Close Icon */}
            <button
              onClick={closeOverlay}
              style={{
                background: 'none',
                border: 'none',
                color: 'red',
                fontSize: '24px',
                cursor: 'pointer',
                marginTop: '20px', 
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default OldDashboard291025;
